import React from 'react';
import './error.css'; 

const Error = () => {
  return (
    <div className='error-wrapper'>
      <div className='error-content'>
        <div className='error-image'></div>
        <div className='error-text'>
          <h3>Looks like you're lost</h3>
          <p>The page you are looking for is not available!</p>
          <a href='/' className='link_404'>Go to Home</a>
        </div>
      </div>
    </div>
  );
};

export default Error;
